/* globals angular */
(function(){
  'use strict';

  var reverseFormV2 = {
    template: require('./reverse-form-v2.html'),
    controller: 'ReverseFormV2Ctrl',
    controllerAs: 'vm'
  };

  angular
    .module('mandaeApp')
    .component('reverseFormV2', reverseFormV2)
    .config(['$qProvider', '$stateProvider', function($qProvider, $stateProvider) {
      $qProvider.errorOnUnhandledRejections(false);
      $stateProvider
        .state('reverse-form-v2', {
          url: '/reversa-v2',
          component: 'reverseFormV2',
          params: {
            originalPackageId: null,
            originalOrderId: null
          }
        });
    }]);

}());
